import { createWithEqualityFn } from 'zustand/traditional';

export type QuickButton = { id: number | 'MAX' | 'CUSTOM'; value: number | null };

export type FantasyEventStore = {
    selectedTab: number;
    actions: {
        setSelectedTab: (tab: number) => void;
    };
};

export const useFantasyEventsTabsStore = createWithEqualityFn<FantasyEventStore>()(
    set => ({
        selectedTab: 0,
        actions: {
            setSelectedTab: tab => {
                set({ selectedTab: tab });
            },
        },
    }),
    Object.is
);
